<script lang="ts">
  import SwiperSlide from '$components/elements/SwiperSlide.svelte';
  import { onMount } from 'svelte';
  import type { SvelteHTMLElements } from 'svelte/elements';
  import 'swiper/css';
  import { register, type SwiperContainer } from 'swiper/element/bundle';
  import type { SwiperOptions } from 'swiper/types';

  type $$Props = SwiperOptions & SvelteHTMLElements['div'];
  let container: SwiperContainer;

  onMount(() => {
    register();
    Object.assign(container, $$restProps);
    container.initialize();
  });

  $$restProps;
</script>

<swiper-container init="false" bind:this={container}>
  <slot Slide={SwiperSlide} />
</swiper-container>
